// src/services/files.js
import { api } from './authService';

export const filesService = {
  // Загрузить файл
  uploadFile: async (file, folder = 'attachments', onProgress = null) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post(`/files/upload?folder=${folder}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            onProgress(percent);
        }
      },
    });
    
    return response.data;
  },
  
  // Удалить файл
  deleteFile: async (url) => {
    const response = await api.delete(`/files/delete?url=${encodeURIComponent(url)}`);
    return response.data;
  },
  
  // Получить информацию о файле
  getFileInfo: async (url) => {
    const response = await api.get(`/files/info?url=${encodeURIComponent(url)}`);
    return response.data;
  },
  
  // Скачать файл
  downloadFile: async (url) => {
    const response = await api.get(`/files/download?url=${encodeURIComponent(url)}`, {
      responseType: 'blob',
    });
    return response.data;
  },
};